<page-data-manager>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2>Integração pluviômetros</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <form id="pluviometro_form" name="pluviometro_form" novalidate ng-submit="save(pluviometro_form)">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Pluviômetros</label>
              <ui-select ng-model="parametros.pluviometro" theme="bootstrap" required>
                <ui-select-match placeholder="Pluviômetros cadastrados">{{$select.selected.descricao | capitalize}}</ui-select-match>
                <ui-select-choices repeat="pluviometro in pluviometros | filter: $select.search">
                  <span class="form-group" ng-bind-html="pluviometro.descricao | capitalize | highlight: $select.search">
                  </span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <label for="file_pluviometro">Arquivo</label>
              <input file-input ng-model="pluviometroFile" type="file" required
                     id="pluviometro_file" name="pluviometro_file" ng-change="changeFile()">
            </div>
          </div>
        </div>
        <div class="row pull-right padding-top-10">
          <div class="col-xs-12 btn-group">
            <button class="btn btn-default btn-sm btn-action" type="button" ng-click="goToIndex()">Cancelar</button>

            <button class="btn btn-success btn-sm btn-action" type="submit" ng-click="upload()"
                    ng-disabled="pluviometro_form.$invalid">
              Upload <i class="fa fa-check"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</page-data-manager>
